import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';

export const useDeleteLayoutVariation = () => {
  return useMutation({
    mutationFn: deleteLayoutVariation,
    onSuccess(data, payload) {
      queryClient.removeQueries(queryKeys.layouts.details(payload));
      queryClient.invalidateQueries(queryKeys.layouts.invalidateAll());
    },
  });
};

const deleteLayoutVariation = async (variationId: number) => {
  const response = await requestCCApi({
    url: `/layouts/${variationId}`,
    method: 'DELETE',
  });

  return response;
};
